import React from "react";
import { ensure } from "sprint-common-web";

import { OrderAuditItem } from "../AuditItem";
import { renderSimpleChangeInfo } from "./renderAuditInfo";

type Props = {
    item: OrderAuditItem;
};

export const MaterialSpecificationChangeInfo: React.FunctionComponent<Props> = ({ item }: Props) => {
    ensure(item.materialSpecification, "Missing material specification");

    const { aspectRatio, bitRate, encodingFormat, resolution } = item.materialSpecification;

    return (
        <>
            {!!aspectRatio &&
                renderSimpleChangeInfo({ from: aspectRatio?.from, to: aspectRatio.to, label: "Aspect Ratio:" })}

            {!!bitRate && renderSimpleChangeInfo({ from: bitRate?.from, to: bitRate.to, label: "Bit rate:" })}

            {!!encodingFormat &&
                renderSimpleChangeInfo({
                    from: encodingFormat?.from,
                    to: encodingFormat.to,
                    label: "Encoding format:"
                })}

            {!!resolution &&
                renderSimpleChangeInfo({ from: resolution?.from, to: resolution.to, label: "Resolution:" })}
        </>
    );
};
